export default __webpack_public_path__ + "static/media/andrey.2db8079e.jpg";